const API_METHOD_KEYS = {
}
// 业务类型
const BizSource = {
  CONSULT: 1,
}

const Scene = {
  PRIVATE_IM: 101,
}
// 接入事件
const EventType = {
  ENTER_IM: 1, // 进入私聊
  REFRESH_IM: 2, // 刷新上下文
  CANCEL_CONSULT: 3, // 取消咨询
  CLOSE_CONSULT: 4, // 关闭咨询
  CONSULT_AGAIN: 5, // 再次咨询
  COMMIT_CONSULT: 6, // 提交主诉
}

export { API_METHOD_KEYS, BizSource, Scene, EventType }
